// bao migrate skip
import * as ko from "knockout";
import Bao from "./../services/bao-service";
import SearchPaging from "./../factories/search-paging";
import BaoDialogViewModel from "./../factories/bao-dialog";
import BaoMenu from "./../services/bao-menu";
import baoRouter from "./../services/bao-router";
import TabPage from "./../factories/tab-page";
// bao migrate - module not found: import Synoset from "modules/synoset-module";
import TabViewModel from "./../factories/tab-controller";
import "./../bindings/bao-date-time-box";
import "./../bindings/bao-date-time-picker";
import "./../bindings/bao-number-box";
import "./../bindings/bao-tabs";
import "./../bindings/bao-toolbar2";
import "./../bindings/bao-upload";
function LicenseRemarkTabViewModel(tabPage, parent) {
    var self = this;
    self.SoftwareLicense = parent;
    self.Refresh = function () { };
}
function LicenseUpgradeTabViewModel(tabPage, parent) {
    var self = this;
    var _msgCancel = Bao.Session.GetMessage("msgCancel");
    var _msgOk = Bao.Session.GetMessage("msgOk");
    var _deleteMessageTypeTab = Bao.Session.GetMessage("msgDeleteSoftwareLicenceUpdate");
    self.Bao = Bao;
    self.UpgradeCollection = ko.observableArray([]);
    self.FilteredUpgradeCollection = ko.observableArray([]);
    self.toolbarClick = function (action) {
        switch (action.ActionKey()) {
            case "AddSoftwareLicenseUpgrade":
                self.ShowSoftwareLicenseUpgradeDialog(parent.SoftwareLicenceId(), null);
                break;
            case "DeleteSoftwareLicenseUpgrade":
                var yesNoDialog = new BaoDialogViewModel(Bao.Session.ApplicationName, _deleteMessageTypeTab, "yesno");
                yesNoDialog.DialogResult.subscribe(function (result) {
                    if (result == true) {
                        self.DeleteSoftwareLicenseUpgrade();
                    }
                });
                break;
            case "EditSoftwareLicenseUpgrade":
                self.ShowSoftwareLicenseUpgradeDialog(parent.SoftwareLicenceId(), self.SelectedRow().SoftwareLicenceUpgradeId);
                break;
            case "RefreshSoftwareLicenseUpgrade":
                self.Refresh();
                break;
        }
    };
    self.SelectedRow = ko.observable({});
    self.SelectedRow.subscribe(function () {
        self.ToggleToolbarButtons();
    });
    self.IsUpdate = ko.observable(false);
    self.IsUpdate.subscribe(function () {
        self.FilterUpgradeCollection();
    });
    self.ToggleToolbarButtons = function () {
        ko.utils.arrayForEach(self.ToolbarButtons(), function (button: any) {
            if (button.ActionKey() == "DeleteSoftwareLicenseUpgrade") {
                button.Enabled(self.SelectedRow() != null);
            }
            if (button.ActionKey() == "EditSoftwareLicenseUpgrade") {
                button.Enabled(self.SelectedRow() != null);
            }
        });
    };
    self.ToolbarButtons = ko.observableArray();
    self.ToolbarButtons.subscribe(function () {
        self.ToggleToolbarButtons();
    });
    self.PageIndex = ko.observable(0);
    self.PageIndex.subscribe(function () {
        self.Refresh();
    });
    self.PageSize = ko.observable(10);
    self.TotalRows = ko.observable(0);
    self.Dialog = new BaoDialogViewModel(Bao.Session.GetMessage("msgUpgrade"));
    self.Dialog.Width("450px");
    self.Dialog.Buttons([{
            Title: _msgOk,
            Click: function () {
                console.log(self.Dialog.ViewModel());
                if (self.Dialog.ViewModel().SoftwareLicenceUpgradeId() != null && self.Dialog.ViewModel().CountOfLicences() != null) {
                    self.AddSoftwareLicenseUpgrade(self.Dialog.ViewModel());
                    self.Dialog.Close();
                }
                else {
                    new BaoDialogViewModel(Bao.Session.GetMessage("msgUpgrade"), Bao.Session.GetMessage("msgFillMandatorFields"), "info");
                }
            },
            Enabled: ko.observable(true)
        }, {
            Title: _msgCancel,
            Click: function () {
                self.Dialog.Close();
            },
            Enabled: ko.observable(true)
        }]);
    self.ShowSoftwareLicenseUpgradeDialog = function (softwareLicenceId, softwareLicenceUpgradeId) {
        Bao.post("License/ShowSoftwareLicenseUpgradeDialog", JSON.stringify({
            sessionTabId: parent.TabPage.SessionTabId,
            softwareLicenceId: softwareLicenceId,
            softwareLicenceUpgradeId: softwareLicenceUpgradeId
        }), function (value) {
            var dialogModel = ko.map.fromJS(value.Model);
            self.Dialog.ViewModel(dialogModel);
            self.Dialog.ViewModel().SoftwareLicenceUpgradeFromId.subscribe(function (value) {
                if (value) {
                    Bao.post("License/Get", JSON.stringify({
                        id: value
                    }), function (model) {
                        if (model) {
                            self.Dialog.ViewModel().LicenceKey(model.LicenceKey);
                            self.Dialog.ViewModel().OrderDateJS(model.OrderDateJS);
                            self.Dialog.ViewModel().OrderNumber(model.OrderNumber);
                        }
                    });
                }
            });
            self.Dialog.Template(value.Message);
            self.Dialog.Open();
        });
    };
    self.AddSoftwareLicenseUpgrade = function (model) {
        tabPage.IsLoading(true);
        return Bao.post("SoftwareLicenseUpgrade/AddSoftwareLicenseUpgrade", JSON.stringify({
            sessionTabId: parent.TabPage.SessionTabId,
            softwareLicenceId: parent.SoftwareLicenceId(),
            softwareLicenseUpgrade: ko.map.toJS(model)
        }), function () {
            parent.TabPage.DirtyFlag(true);
            self.Refresh();
        });
    };
    self.DeleteSoftwareLicenseUpgrade = function () {
        tabPage.IsLoading(true);
        return Bao.post("SoftwareLicenseUpgrade/DeleteSoftwareLicenseUpgrade", JSON.stringify({
            sessionTabId: parent.TabPage.SessionTabId,
            softwareLicenceUpgradeId: self.SelectedRow().SoftwareLicenceUpgradeId
        }), function () {
            parent.TabPage.DirtyFlag(true);
            self.Refresh();
        });
    };
    self.FilterUpgradeCollection = function () {
        self.FilteredUpgradeCollection([]);
        for (var i = 0, len = self.UpgradeCollection().length; i < len; i++) {
            if (self.IsUpdate() && self.UpgradeCollection()[i].IsUpdate || !self.IsUpdate() && !self.UpgradeCollection()[i].IsUpdate) {
                self.FilteredUpgradeCollection.push(self.UpgradeCollection()[i]);
            }
        }
    };
    self.Refresh = function () {
        tabPage.IsLoading(true);
        return Bao.post("SoftwareLicenseUpgrade/GetSoftwareLicenseUpgradeCollection", JSON.stringify({
            sessionTabId: parent.TabPage.SessionTabId,
            softwareLicenceUpgradeId: parent.SoftwareLicenceId(),
            pageIndex: self.PageIndex(),
            pageSize: self.PageSize(),
            sorting: null
        }), function (searchResult) {
            self.SelectedRow(null);
            self.TotalRows(0);
            self.UpgradeCollection([]);
            if (searchResult != null && searchResult.Models != null) {
                self.UpgradeCollection(searchResult.Models);
                self.FilterUpgradeCollection();
                self.TotalRows(searchResult.TotalRows);
                self.ToggleToolbarButtons();
            }
            tabPage.IsLoading(false);
        });
    };
}
;
function LicenseDowngradeTabViewModel(tabPage, parent) {
    var self = this;
    var _msgCancel = Bao.Session.GetMessage("msgCancel");
    var _msgOk = Bao.Session.GetMessage("msgOk");
    var _deleteMessageTypeTab = Bao.Session.GetMessage("msgDeleteSoftwareLicenceDowngrade");
    self.Bao = Bao;
    self.DowngradeCollection = ko.observableArray([]);
    self.Software = ko.observable();
    self.SelectedSoftwareId = ko.observable();
    self.ShowSoftwareDialog = function () { };
    self.toolbarClick = function (action) {
        switch (action.ActionKey()) {
            case "AddSoftwareLicenseDowngrade":
                self.ShowSoftwareDialog();
                break;
            case "DeleteSoftwareLicenseDowngrade":
                var yesNoDialog = new BaoDialogViewModel(Bao.Session.ApplicationName, _deleteMessageTypeTab, "yesno");
                yesNoDialog.DialogResult.subscribe(function (result) {
                    if (result == true) {
                        self.DeleteSoftwareLicenseDowngrade();
                    }
                });
                break;
            case "RefreshSoftwareLicenseDowngrade":
                self.Refresh();
                break;
        }
    };
    self.SelectedRow = ko.observable({});
    self.SelectedRow.subscribe(function () {
        self.ToggleToolbarButtons();
    });
    self.DowngradeAllowed = ko.observable(false);
    self.DowngradeAllowed.subscribe(function () {
        self.Refresh();
    });
    self.Software.subscribe(function () {
        self.AddSoftwareLicenseDowngrade();
    });
    self.ToggleToolbarButtons = function () {
        ko.utils.arrayForEach(self.ToolbarButtons(), function (button: any) {
            if (button.ActionKey() == "DeleteSoftwareLicenseDowngrade") {
                button.Enabled(self.SelectedRow() != null);
            }
        });
    };
    self.ToolbarButtons = ko.observableArray();
    self.ToolbarButtons.subscribe(function () {
        self.ToggleToolbarButtons();
    });
    self.PageIndex = ko.observable(0);
    self.PageIndex.subscribe(function () {
        self.Refresh();
    });
    self.PageSize = ko.observable(10);
    self.TotalRows = ko.observable(0);
    self.AddSoftwareLicenseDowngrade = function () {
        tabPage.IsLoading(true);
        return Bao.post("SoftwareLicenseDowngrade/AddSoftwareLicenseDowngrade", JSON.stringify({
            sessionTabId: parent.TabPage.SessionTabId,
            softwareLicenceId: parent.SoftwareLicenceId(),
            softwareId: self.Software().SoftwareId
        }), function () {
            parent.TabPage.DirtyFlag(true);
            self.Refresh();
        });
    };
    self.DeleteSoftwareLicenseDowngrade = function () {
        tabPage.IsLoading(true);
        return Bao.post("SoftwareLicenseDowngrade/DeleteSoftwareLicenseDowngrade", JSON.stringify({
            sessionTabId: parent.TabPage.SessionTabId,
            softwareId: self.SelectedRow().SoftwareId
        }), function () {
            parent.TabPage.DirtyFlag(true);
            self.Refresh();
        });
    };
    self.Refresh = function () {
        tabPage.IsLoading(true);
        return Bao.post("SoftwareLicenseDowngrade/GetSoftwareLicenseDowngradeCollection", JSON.stringify({
            sessionTabId: parent.TabPage.SessionTabId,
            softwareLicenceDowngradeId: parent.SoftwareLicenceId(),
            downgradeAllowed: self.DowngradeAllowed(),
            pageIndex: self.PageIndex(),
            pageSize: self.PageSize(),
            sorting: null
        }), function (searchResult) {
            self.SelectedRow(null);
            self.TotalRows(0);
            self.DowngradeCollection([]);
            if (searchResult != null && searchResult.Models != null) {
                self.DowngradeCollection(searchResult.Models);
                self.TotalRows(searchResult.TotalRows);
                self.ToggleToolbarButtons();
            }
            tabPage.IsLoading(false);
        });
    };
}
;
function LicenseCustomerTabViewModel(tabPage, parent) {
    var self = this;
    var _msgCancel = Bao.Session.GetMessage("msgCancel");
    var _msgOk = Bao.Session.GetMessage("msgOk");
    var _deleteMessageTypeTab = Bao.Session.GetMessage("msgDeleteSoftwareLicenceCustomer");
    self.Bao = Bao;
    self.CustomerCollection = ko.observableArray([]);
    self.toolbarClick = function (action) {
        switch (action.ActionKey()) {
            case "AddSoftwareLicenseCustomer":
                self.ShowSoftwareLicenseCustomerDialog(parent.SoftwareLicenceId(), null);
                break;
            case "DeleteSoftwareLicenseCustomer":
                var yesNoDialog = new BaoDialogViewModel(Bao.Session.ApplicationName, _deleteMessageTypeTab, "yesno");
                yesNoDialog.DialogResult.subscribe(function (result) {
                    if (result == true) {
                        self.DeleteSoftwareLicenseCustomer();
                    }
                });
                break;
            case "EditSoftwareLicenseCustomer":
                self.ShowSoftwareLicenseCustomerDialog(parent.SoftwareLicenceId(), self.SelectedRow().SoftwareLicenceCustomerId);
                break;
            case "RefreshSoftwareLicenseCustomer":
                self.Refresh();
                break;
        }
    };
    self.SelectedRow = ko.observable({});
    self.SelectedRow.subscribe(function () {
        self.ToggleToolbarButtons();
    });
    self.ToggleToolbarButtons = function () {
        ko.utils.arrayForEach(self.ToolbarButtons(), function (button: any) {
            if (button.ActionKey() == "DeleteSoftwareLicenseCustomer") {
                button.Enabled(self.SelectedRow() != null);
            }
            if (button.ActionKey() == "EditSoftwareLicenseCustomer") {
                button.Enabled(self.SelectedRow() != null);
            }
        });
    };
    self.ToolbarButtons = ko.observableArray();
    self.ToolbarButtons.subscribe(function () {
        self.ToggleToolbarButtons();
    });
    self.PageIndex = ko.observable(0);
    self.PageIndex.subscribe(function () {
        self.Refresh();
    });
    self.PageSize = ko.observable(10);
    self.TotalRows = ko.observable(0);
    self.Dialog = new BaoDialogViewModel(Bao.Session.GetMessage("msgSoftwareLicenseCustomer"));
    self.Dialog.Width("450px");
    self.Dialog.Buttons([{
            Title: _msgOk,
            Click: function () {
                console.log(self.Dialog.ViewModel());
                if (self.Dialog.ViewModel().CustomerId() != null && self.Dialog.ViewModel().CountOfLicences() != null) {
                    self.AddSoftwareLicenseCustomer(self.Dialog.ViewModel());
                    self.Dialog.Close();
                }
                else {
                    new BaoDialogViewModel(Bao.Session.GetMessage("msgSoftwareLicenseCustomer"), Bao.Session.GetMessage("msgFillMandatorFields"), "info");
                }
            },
            Enabled: ko.observable(true)
        }, {
            Title: _msgCancel,
            Click: function () {
                self.Dialog.Close();
            },
            Enabled: ko.observable(true)
        }]);
    self.ShowSoftwareLicenseCustomerDialog = function (softwareLicenceId, softwareLicenceCustomerId) {
        Bao.post("License/ShowSoftwareLicenseCustomerDialog", JSON.stringify({
            sessionTabId: parent.TabPage.SessionTabId,
            softwareLicenceId: softwareLicenceId,
            softwareLicenceCustomerId: softwareLicenceCustomerId
        }), function (value) {
            var dialogModel = ko.map.fromJS(value.Model);
            self.Dialog.ViewModel(dialogModel);
            self.Dialog.Template(value.Message);
            self.Dialog.Open();
        });
    };
    self.AddSoftwareLicenseCustomer = function (model) {
        tabPage.IsLoading(true);
        return Bao.post("SoftwareLicenseCustomer/AddSoftwareLicenseCustomer", JSON.stringify({
            sessionTabId: parent.TabPage.SessionTabId,
            softwareLicenceId: parent.SoftwareLicenceId(),
            softwareLicenseCustomer: ko.map.toJS(model)
        }), function () {
            parent.TabPage.DirtyFlag(true);
            self.Refresh();
        });
    };
    self.DeleteSoftwareLicenseCustomer = function () {
        tabPage.IsLoading(true);
        return Bao.post("SoftwareLicenseCustomer/DeleteSoftwareLicenseCustomer", JSON.stringify({
            sessionTabId: parent.TabPage.SessionTabId,
            softwareLicenceCustomerId: self.SelectedRow().SoftwareLicenceCustomerId
        }), function () {
            parent.TabPage.DirtyFlag(true);
            self.Refresh();
        });
    };
    self.Refresh = function () {
        tabPage.IsLoading(true);
        return Bao.post("SoftwareLicenseCustomer/GetSoftwareLicenseCustomerCollection", JSON.stringify({
            sessionTabId: parent.TabPage.SessionTabId,
            softwareLicenceId: parent.SoftwareLicenceId(),
            pageIndex: self.PageIndex(),
            pageSize: self.PageSize(),
            sorting: null
        }), function (searchResult) {
            self.SelectedRow(null);
            self.TotalRows(0);
            self.CustomerCollection([]);
            if (searchResult != null && searchResult.Models != null) {
                self.CustomerCollection(searchResult.Models);
                self.TotalRows(searchResult.TotalRows);
                self.ToggleToolbarButtons();
            }
            tabPage.IsLoading(false);
        });
    };
}
;
function LicenseDocumentTabViewModel(tabPage, parent) {
    var self = this;
    var _msgCancel = Bao.Session.GetMessage("msgCancel");
    var _msgOk = Bao.Session.GetMessage("msgOk");
    var _deleteMessageTypeTab = Bao.Session.GetMessage("msgDeleteSoftwareLicenceDocument");
    self.Bao = Bao;
    self.DocumentCollection = ko.observableArray([]);
    self.toolbarClick = function (action) {
        switch (action.ActionKey()) {
            case "AddSoftwareLicenseDocument":
                self.ShowSoftwareLicenseDocumentDialog(parent.SoftwareLicenceId());
                break;
            case "DeleteSoftwareLicenseDocument":
                var yesNoDialog = new BaoDialogViewModel(Bao.Session.ApplicationName, _deleteMessageTypeTab, "yesno");
                yesNoDialog.DialogResult.subscribe(function (result) {
                    if (result == true) {
                        self.DeleteSoftwareLicenseDocument();
                    }
                });
                break;
            case "RefreshSoftwareLicenseDocument":
                self.Refresh();
                break;
            case "DownloadSoftwareLicenseDocument":
                self.DownloadSoftwareLicenseDocument();
                break;
        }
    };
    self.SelectedRow = ko.observable({});
    self.SelectedRow.subscribe(function () {
        self.ToggleToolbarButtons();
    });
    self.ToggleToolbarButtons = function () {
        ko.utils.arrayForEach(self.ToolbarButtons(), function (button: any) {
            if (button.ActionKey() == "DeleteSoftwareLicenseDocument") {
                button.Enabled(self.SelectedRow() != null);
            }
            if (button.ActionKey() == "DownloadSoftwareLicenseDocument") {
                button.Enabled(self.SelectedRow() != null);
            }
        });
    };
    self.ToolbarButtons = ko.observableArray();
    self.ToolbarButtons.subscribe(function () {
        self.ToggleToolbarButtons();
    });
    self.PageIndex = ko.observable(0);
    self.PageIndex.subscribe(function () {
        self.Refresh();
    });
    self.PageSize = ko.observable(10);
    self.TotalRows = ko.observable(0);
    self.Dialog = new BaoDialogViewModel(Bao.Session.GetMessage("msgDocument"));
    self.Dialog.Width("450px");
    self.Dialog.Buttons([{
            Title: _msgOk,
            Click: function () {
                console.log(self.Dialog.ViewModel());
                if (self.Dialog.ViewModel().SoftwareLicenceDocumentId() != null) {
                    self.Dialog.IsLoading(true);
                    $.when(self.Dialog.ViewModel().Upload()).then(function () {
                        self.Dialog.IsLoading(false);
                        self.AddSoftwareLicenseDocument(self.Dialog.ViewModel());
                        self.Dialog.Close();
                    });
                }
                else {
                    new BaoDialogViewModel(Bao.Session.GetMessage("msgDocument"), Bao.Session.GetMessage("msgFillMandatorFields"), "info");
                }
            },
            Enabled: ko.observable(true)
        }, {
            Title: _msgCancel,
            Click: function () {
                self.Dialog.Close();
            },
            Enabled: ko.observable(true)
        }]);
    self.ShowSoftwareLicenseDocumentDialog = function (softwareLicenceId) {
        Bao.post("License/ShowSoftwareLicenseDocumentDialog", JSON.stringify({
            sessionTabId: parent.TabPage.SessionTabId,
            softwareLicenceId: softwareLicenceId
        }), function (value) {
            var dialogModel = ko.map.fromJS(value.Model);
            dialogModel.Upload = function () { };
            self.Dialog.ViewModel(dialogModel);
            self.Dialog.Template(value.Message);
            self.Dialog.Open();
        });
    };
    self.AddSoftwareLicenseDocument = function (model) {
        tabPage.IsLoading(true);
        return Bao.post("SoftwareLicenseDocument/AddSoftwareLicenseDocument", JSON.stringify({
            sessionTabId: parent.TabPage.SessionTabId,
            softwareLicenceId: parent.SoftwareLicenceId(),
            softwareLicenseDocument: ko.map.toJS(model)
        }), function () {
            parent.TabPage.DirtyFlag(true);
            self.Refresh();
        });
    };
    self.DeleteSoftwareLicenseDocument = function () {
        tabPage.IsLoading(true);
        return Bao.post("SoftwareLicenseDocument/DeleteSoftwareLicenseDocument", JSON.stringify({
            sessionTabId: parent.TabPage.SessionTabId,
            softwareLicenceDocumentId: self.SelectedRow().SoftwareLicenceDocumentId
        }), function () {
            parent.TabPage.DirtyFlag(true);
            self.Refresh();
        });
    };
    self.DownloadSoftwareLicenseDocument = function () {
        window.open("SoftwareLicenseDocument/DownloadSoftwareLicenseDocument?id=" + self.SelectedRow().SoftwareLicenceDocumentId);
    };
    self.Refresh = function () {
        tabPage.IsLoading(true);
        return Bao.post("SoftwareLicenseDocument/GetSoftwareLicenseDocumentCollection", JSON.stringify({
            sessionTabId: parent.TabPage.SessionTabId,
            softwareLicenceId: parent.SoftwareLicenceId(),
            pageIndex: self.PageIndex(),
            pageSize: self.PageSize(),
            sorting: null
        }), function (searchResult) {
            self.SelectedRow(null);
            self.TotalRows(0);
            self.DocumentCollection([]);
            if (searchResult != null && searchResult.Models != null) {
                self.DocumentCollection(searchResult.Models);
                self.TotalRows(searchResult.TotalRows);
                self.ToggleToolbarButtons();
            }
            tabPage.IsLoading(false);
        });
    };
}
;
function LicenseViewModel(tabPage) {
    var self = this;
    SearchPaging.call(this, tabPage);
    self.TabViewModel = new TabViewModel(false);
    self.TabPage = tabPage;
    var tabPageRemark = new TabPage();
    tabPageRemark.AutoSelect = true;
    tabPageRemark.Url("License/LicenseRemarkTab");
    tabPageRemark.Title = Bao.Session.GetMessage("msgRemark");
    tabPageRemark.IsClosable(false);
    tabPageRemark.ViewModel(new LicenseRemarkTabViewModel(tabPageRemark, self));
    tabPageRemark.TabLoaded = function () {
        tabPageRemark.ViewModel().Refresh();
    };
    var tabPageUpgrade = new TabPage();
    tabPageUpgrade.AutoSelect = false;
    tabPageUpgrade.PreLoad(false);
    tabPageUpgrade.Url("License/LicenseUpgradeTab");
    tabPageUpgrade.Title = Bao.Session.GetMessage("msgUpgrade");
    tabPageUpgrade.IsClosable(false);
    tabPageUpgrade.ViewModel(new LicenseUpgradeTabViewModel(tabPageUpgrade, self));
    tabPageUpgrade.TabLoaded = function () {
        tabPageUpgrade.ViewModel().Refresh();
    };
    var tabPageDowngrade = new TabPage();
    tabPageDowngrade.AutoSelect = false;
    tabPageDowngrade.PreLoad(false);
    tabPageDowngrade.Url("License/LicenseDowngradeTab");
    tabPageDowngrade.Title = Bao.Session.GetMessage("msgDowngrade");
    tabPageDowngrade.IsClosable(false);
    tabPageDowngrade.ViewModel(new LicenseDowngradeTabViewModel(tabPageDowngrade, self));
    tabPageDowngrade.TabLoaded = function () {
        tabPageDowngrade.ViewModel().Refresh();
    };
    var tabPageCustomer = new TabPage();
    tabPageCustomer.AutoSelect = false;
    tabPageCustomer.PreLoad(false);
    tabPageCustomer.Url("License/LicenseCustomerTab");
    tabPageCustomer.Title = Bao.Session.GetMessage("msgSoftwareLicenseCustomer");
    tabPageCustomer.IsClosable(false);
    tabPageCustomer.ViewModel(new LicenseCustomerTabViewModel(tabPageCustomer, self));
    tabPageCustomer.TabLoaded = function () {
        tabPageCustomer.ViewModel().Refresh();
    };
    var tabPageDocument = new TabPage();
    tabPageDocument.AutoSelect = false;
    tabPageDocument.PreLoad(false);
    tabPageDocument.Url("License/LicenseDocumentTab");
    tabPageDocument.Title = Bao.Session.GetMessage("msgReferenceDocuments");
    tabPageDocument.IsClosable(false);
    tabPageDocument.ViewModel(new LicenseDocumentTabViewModel(tabPageDocument, self));
    tabPageDocument.TabLoaded = function () {
        tabPageDocument.ViewModel().Refresh();
    };
    self.Save = function () {
        tabPage.IsLoading(true);
        return Bao.post("License/SaveLicense", JSON.stringify({
            sessionTabId: tabPage.SessionTabId,
            licenseModel: self.MinimizeEntity()
        }), function (value) {
            self.SaveTime(value.Result);
            self.PerformRefresh(true);
            if (tabPageDocument) {
                tabPageDocument.ViewModel().Refresh();
            }
        });
    };
    var baseLoaded = self.loaded;
    self.loaded = function () {
        self.TabViewModel.AddTab(tabPageRemark);
        self.TabViewModel.AddTab(tabPageUpgrade);
        self.TabViewModel.AddTab(tabPageDowngrade);
        self.TabViewModel.AddTab(tabPageCustomer);
        self.TabViewModel.AddTab(tabPageDocument);
        if (baseLoaded != null) {
            baseLoaded.call(self);
        }
    };
    self.CompleteCheck = function () {
        var isComplete = true;
        if (Bao.Utils.String.IsNullOrEmpty(self.SoftwareName())) {
            isComplete = false;
        }
        if (Bao.Utils.String.IsNullOrEmpty(self.LicenceKey())) {
            isComplete = false;
        }
        if (Bao.Utils.String.IsNullOrEmpty(self.CountOfLicences())) {
            isComplete = false;
        }
        if (!isComplete) {
            new BaoDialogViewModel(Bao.Session.ApplicationName, Bao.Session.GetMessage("msgFillMandatorFields"), "info");
        }
        return isComplete;
    };
    self.SoftwareId = ko.observable();
    self.SoftwareId.subscribe(function (value) {
        if (value) {
            Bao.post("Software/Get", JSON.stringify({
                id: value
            }), function (returnValue) {
                Bao.post("SoftwareType/Get", JSON.stringify({
                    id: returnValue.SoftwareTypeId
                }), function (model) {
                    self.SoftwareTypeName(model ? model.Name : "");
                });
            });
        }
    });
    var baseInit = self.init;
    self.init = function () {
        var def = $.Deferred();
        var softwareLicencePoolId = baoRouter.getRouteValue("softwarelicencepoolid", self.TabPage);
        if (baseInit != null) {
            baseInit.call(self).then(function () {
                if (softwareLicencePoolId != null) {
                    self.SoftwareLicencePoolId(softwareLicencePoolId);
                    Bao.post("SoftwareLicensePool/Get", JSON.stringify({
                        id: softwareLicencePoolId
                    }), function (model) {
                        self.CustomerName(model.CustomerName);
                    });
                }
                def.resolve();
            });
        }
        return def.promise();
    };
}
Bao.inherit(LicenseViewModel, SearchPaging);
LicenseViewModel.prototype.PrimaryKey = "SoftwareLicenceId";
LicenseViewModel.prototype.RefreshUrl = "License/Get";
LicenseViewModel.prototype.SaveUrl = "License/Save";
LicenseViewModel.prototype.DeleteUrl = "License/Delete";
LicenseViewModel.prototype.IsInUseUrl = "License/IsInUse";
LicenseViewModel.prototype.PermissionForward = "LicenseMoveForwardSearch";
LicenseViewModel.prototype.PermissionBackward = "LicenseMoveBackwardSearch";
LicenseViewModel.prototype.PermissionSave = "LicenseSave";
LicenseViewModel.prototype.PermissionRefresh = "LicenseRefresh";
LicenseViewModel.prototype.PermissionDelete = "LicenseDelete";
export default LicenseViewModel;